module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Top-bar', {
    attrs: {
      "domain": _vm.domainName,
      "domain-info": _vm.domainInfo
    }
  }), _vm._v(" "), _c('VAside', {
    attrs: {
      "sidebar-menus": _vm.sidebarMenus,
      "headerHeight": "90"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', {
    staticClass: "job-detail-header"
  }, [_c('div', {
    staticClass: "pull-left job-detail-title"
  }, [_c('span', {
    staticClass: "job-span"
  }, [(_vm.jobInfo.jobType === 'JAVA_JOB') ? _c('i', {
    staticClass: "iconfont icon-java"
  }) : _vm._e(), _vm._v(" "), (_vm.jobInfo.jobType === 'SHELL_JOB') ? _c('i', {
    staticClass: "iconfont icon-msnui-logo-linux"
  }) : _vm._e(), _vm._v(" "), (_vm.jobInfo.jobType === 'MSG_JOB') ? _c('i', {
    staticClass: "fa fa-envelope-o"
  }) : _vm._e(), _vm._v("\n                    作业 : " + _vm._s(_vm.jobName) + "\n                ")]), _vm._v(" "), _c('el-tag', {
    staticClass: "status-tag",
    attrs: {
      "type": _vm.statusTag[_vm.jobInfo.status]
    }
  }, [_vm._v("运行状态: " + _vm._s(_vm.translateStatus[_vm.jobInfo.status]))])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [(_vm.$common.hasPerm('job:enable', _vm.domainName) && (_vm.jobInfo.status === 'STOPPING' || _vm.jobInfo.status === 'STOPPED')) ? _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.handleActive(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play-circle text-btn"
  }), _vm._v("启用")]) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('job:disable', _vm.domainName) && (_vm.jobInfo.status === 'READY' || _vm.jobInfo.status === 'RUNNING')) ? _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.handleActive(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-stop-circle text-warning"
  }), _vm._v("禁用")]) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('job:runAtOnce', _vm.domainName) && (_vm.jobInfo.status === 'READY' && _vm.jobStatusJudge() && !_vm.$option.isMsg(_vm.jobInfo.jobType))) ? _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.handleOperate('runAtOnce')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o text-btn"
  }), _vm._v("立即执行")]) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('job:stopAtOnce', _vm.domainName) && _vm.jobInfo.status === 'STOPPING') ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.handleOperate('stopAtOnce')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-stop-circle-o"
  }), _vm._v("立即终止")]) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('job:remove', _vm.domainName) && (_vm.jobInfo.status === 'STOPPED' || !_vm.jobInfo.enabled)) ? _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleDelete
    }
  }, [_c('i', {
    staticClass: "fa fa-trash text-danger"
  }), _vm._v("删除")]) : _vm._e()], 1)]), _vm._v(" "), _c('router-view')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e471d94a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/job_detail/job_detail.vue
// module id = 1444
// module chunks = 1